import { render, staticRenderFns } from "./EnergySource.vue?vue&type=template&id=87a8fbda&scoped=true"
import script from "./EnergySource.vue?vue&type=script&lang=js"
export * from "./EnergySource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a8fbda",
  null
  
)

export default component.exports